import clsx from "clsx";
import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { VIRTUAL_BACKGROUND } from "../../constants/VirtualBackgroundConstant";

const VirtualBackgroundDefaultImages = ({ handleButtonClick, localisedValues }) => {
    const { virtualBackgroundImages, selectedVirtualBackgroundImageId } = useSelector((state) => state.callSetting);

    return (
        <div className='default-virtual-background'>
            <div className='title'>{localisedValues?.default_image}</div>
            <div className='default-vb-row'>
                {virtualBackgroundImages?.map((data) => {
                    return (
                        <div className='default-vb-col' key={data.id}>
                            <div className={clsx("default-virtual-background-box", selectedVirtualBackgroundImageId === data.id && "selected-image")}>
                                <div className='default-vb-image'>
                                    <img
                                        className='default-vb-img'
                                        src={data.id === VIRTUAL_BACKGROUND.LOCAL_IMAGE_ID ? data.image : process.env.PUBLIC_URL + data.image}
                                        alt='Default Virtual Background'
                                    />
                                </div>
                                {selectedVirtualBackgroundImageId !== data.id && (
                                    <button className='default-vb-selection-btn' onClick={() => handleButtonClick(data.id, data.image)}></button>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

VirtualBackgroundDefaultImages.propTypes = {
    localisedValues: PropTypes.any,
    handleButtonClick: PropTypes.func,
};

export default VirtualBackgroundDefaultImages;
